export default {
  default: () => import("/home/forge/amosweb.de/releases/20250506200506/newsletters/layouts/default.vue").then(m => m.default || m),
  "newsletter-show": () => import("/home/forge/amosweb.de/releases/20250506200506/newsletters/layouts/newsletterShow.vue").then(m => m.default || m),
  "newsletter-subscription": () => import("/home/forge/amosweb.de/releases/20250506200506/newsletters/layouts/newsletterSubscription.vue").then(m => m.default || m)
}